import React, { useState } from 'react';
import './Nav.css';
import NavTab from './NavTab';
import NavTitle from './NavTitle';

import SvgDirectory from '../../svg/Directory';
import SvgLocation from '../../svg/Location';
import SvgContact from '../../svg/Contact';
import SvgInfo from '../../svg/Info';
import { useSelect } from '@mui/base';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import { IBuilding } from '../../pages/types';
import axios from '../../api/axios';

export interface INavProps {}

const Nav: React.FC<INavProps> = () => {
    const defaultBuilding: IBuilding = {
        id: -1,
        name: 'Not Found',
        address: 'Not Found',
        region: 'Not Found',
        country: 'Not Found',
        postalCode: 'Not Found'
    };

    const [activeTab, setActiveTab] = useState(0);
    const [building, setBuilding] = useState<IBuilding>(defaultBuilding);
    const { BuildingId } = useSelector((state: RootState) => state.buildingId);
    const GET_BUILDING_URL = '/api/hblogin/repository/GetBuildingById';
    React.useEffect(() => {
        axios.get<IBuilding>(`${GET_BUILDING_URL}`, { params: { id: BuildingId } }).then((response) => setBuilding(response.data));
    }, []);

    const colour = (index: number): string => {
        return activeTab === index ? '#00A758' : '#424559';
    };
    const directory = (<SvgDirectory height={'5.56vh'} width={'5.56vh'} color={colour(1)} />) as React.HTMLAttributes<HTMLDivElement>;
    const contact = (<SvgContact height={'5.56vh'} width={'5.56vh'} color={colour(2)} />) as React.HTMLAttributes<HTMLDivElement>;
    const info = (<SvgInfo height={'5.56vh'} width={'5.56vh'} color={colour(3)} />) as React.HTMLAttributes<HTMLDivElement>;
    const location = (<SvgLocation height={'5.56vh'} width={'5.56vh'} color={colour(4)} />) as React.HTMLAttributes<HTMLDivElement>;

    return (
        <div className="Navbar">
            <NavTitle index={0} street={building.name} title={'Welcome'} to={`/${BuildingId}`} setActiveTab={setActiveTab} />
            <NavTab index={1} icon={directory} title={'Directory'} to={`/Directory/${BuildingId}`} setActiveTab={setActiveTab} />
            <NavTab index={2} icon={contact} title={'Contacts'} to={`/Contacts/${BuildingId}`} setActiveTab={setActiveTab} />
            <NavTab index={3} icon={info} title={'Information'} to={`/Informations/${BuildingId}`} setActiveTab={setActiveTab} />
        </div>
    );
};

export default Nav;
